export default __webpack_public_path__ + "static/media/logo-transparent.3a09b3a6.png";